module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="calendacc-customBar form-row">\r\n    <div class="form-group" style="text-align: center">\r\n        <span class="arrow leftArrow">'+
((__t=(UTILS.getSVGIcon("fleche_pleine_gauche","cw-icon--primary")))==null?'':__t)+
'</span>\r\n    </div>\r\n    <div class="form-group">\r\n        <label for="year_id" style="display:none" aria-hidden="false">'+
((__t=(i18n.t('calendacc.year')))==null?'':__t)+
'</label>\r\n        <input type="text" class="year_id year form-control cw-texteAllege--selectionne" value="" maxlength="4" />\r\n    </div>\r\n    <div class="form-group" style="text-align: center">\r\n        <span class="arrow rightArrow">'+
((__t=(UTILS.getSVGIcon("fleche_pleine_droite","cw-icon--primary")))==null?'':__t)+
'</span>\r\n    </div>\r\n</div>\r\n</div>';
}
return __p;
};
